import type {Experiment} from '@wix/document-services-types'

export const areSomeOpen = (experiment: Experiment, experiments: string[]) =>
    experiments.some(exp => experiment.isOpen(exp))
export const areAllOpen = (experiment: Experiment, experiments: string[]) =>
    experiments.every(exp => experiment.isOpen(exp))
